/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { isEmpty } from 'lodash'

import classes from 'classnames'

import { ui } from '../redux'

import MenuIcon from '../components/MenuIcon'

const SidebarMenuItem = ({ label, link, icon, children, isOpen, isActive, dispatch }) => (
    isEmpty(children) ? (
        <li className={ classes({ active: isActive }) }>
            <Link to={ link }>
                <MenuIcon icon={ icon } />
                <span>{ label }</span>
            </Link>
        </li>
    ) : (
        <li className={ classes('parent', { open: isOpen, active: isActive }) }>
            <a role="menuitem" onClick={ () => dispatch(ui.toggleMenu(label, ui.MENUS.sidebar)) }>
                <MenuIcon icon={ icon } />
                <span>{ label }</span>
            </a>
            <ul className="sub-menu">
                { children }
            </ul>
        </li>
    )
)

SidebarMenuItem.propTypes = {
    dispatch : PropTypes.func.isRequired,
    label    : PropTypes.string.isRequired,
    link     : PropTypes.string,
    icon     : PropTypes.node,
    isOpen   : PropTypes.bool,
    isActive : PropTypes.bool
}

SidebarMenuItem.defaultProps = {
    isOpen   : false,
    isActive : false
}

function mapStateToProps(state, ownProps) {
    const { label, link } = ownProps
    const { routing: { url } } = state

    return {
        isOpen   : ui.isMenuOpen(label, ui.MENUS.sidebar)(state),
        isActive : url === link
    }
}

export default connect(mapStateToProps)(SidebarMenuItem)
